import React from 'react';
import PropTypes from 'prop-types';
import { useGlobalData } from '../context/globalData';


function UrgentStatus(props) {
  const { globalData } = useGlobalData();
  const { carousel } = props;

  const urgentCarousel = globalData.carousels.filter(
    (item) => item.languageID === carousel.languageID && item.type === 2,
  )[0];

  return (
    <div
      className="flex items-center space-x-2 w-full justify-self-end col-start-2"
      style={{ minWidth: '160px', maxWidth: '160px' }}
    >
        {(urgentCarousel.isActive) ? 
            <span className='urgent-status'>
                MODE URGENT ON
            </span> :
            <span />
        }
    </div>
  );
}

UrgentStatus.propTypes = {
  carousel: PropTypes.object
};
UrgentStatus.defaultProps = {
  carousel: {}
};

export default UrgentStatus;
